import React, {Component} from 'react';
import PropTypes from "prop-types";
import WithUserState from "./user/WithUserState";
import Icon from "./Icon";
import SignInButton from "./user/SignInButton";
import VoteApi from "../api/VoteApi";

class SubscribeButton extends Component {
  static propTypes = {
    tag: PropTypes.string.isRequired,
    loadSubscribed: PropTypes.bool,
    subscribed: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.state = {
      subscribed: this.props.subscribed || false
    }
  }

  componentDidMount() {
    const { loadSubscribed } = this.props;

    if (loadSubscribed && window.user.signedIn()) {
      const { tag } = this.props;

      VoteApi.subscribed("tag", tag).then(res => {
        this.setState({
          subscribed: res.data.data.status
        })
      })
    }
  }

  onButtonClick(e) {
    const { tag } = this.props;

    if (this.state.loading) {
      return;
    }

    this.setState({
      loading: true
    }, () => {
      VoteApi.subscribeTo("tag", tag).then(res => {
        this.setState({
          loading: false,
          subscribed: res.data.status
        });
      })
    });

    return false;
  }

  render() {
    const { tag } = this.props;
    const { subscribed } = this.state;

    let classes = ["btn btn-block"];
    if (this.props.className) {
      classes.push(this.props.className);
    }

    if (subscribed) {
      classes.push("btn-primary");
    } else {
      classes.push("btn-default");
    }

    if (this.props.className === false) {
      classes = ["subscribe-button"];
    }

    if (subscribed) {
      classes.push("subscribed");
    }

    return (
      <React.Fragment>
        <WithUserState state={"loggedIn"}>
          <button className={classes.join(" ")} onClick={this.onButtonClick.bind(this)} aria-label={`${subscribed ? "Unsubscribe from" : "Subscribe to"} to ${tag}`} data-balloon-pos="up">
            {this.props.children || <React.Fragment><Icon icon={'bell'}/> {subscribed ? "Unsubscribe from" : "Subscribe to"} {tag}</React.Fragment>}
          </button>
        </WithUserState>
        <WithUserState state={"loggedOut"}>
          <div aria-label={`Subscribe to ${tag}`} data-balloon-pos="up"><SignInButton className={classes.join(" ")}>{this.props.children || <React.Fragment><Icon icon={'bell'}/> Subscribe to {tag}</React.Fragment>}</SignInButton></div>
        </WithUserState>
      </React.Fragment>
    );
  }
}

export default SubscribeButton;